module.exports = __webpack_public_path__ + "img/leandro.d008cc00.jpg";